import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';
import moment from 'moment';

(function() {
    'use strict';

    angular.module('app').component('payment2', {
        template: require('./payment-module.html'),
        controller: PaymentModuleCtrl,
        controllerAs: 'vm'
    });

    PaymentModuleCtrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function PaymentModuleCtrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;
        vm.isPassword = false;
        vm.logo = require('Images/nav-logo.png');
        vm.dayoungx2co = require('Images/dayoungx2co.png');
        // The header text on top most of the page
        vm.header = 'Login';

        vm.id = $stateParams.id;


        vm.data = {};

        vm.getData = () => {

            var request = {
                method: 'GET',
                route: URLS.base + `/regular_class/${vm.id}`,
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.data = response.data.data;
                        vm.data.created_formatted = moment(vm.data.created).format('DD MMM YYYY');
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }
        vm.getData();

        window.expose_vm = () => vm;

        // setInterval(() => {
        //     console.log('truth', vm.truth);
        // }, 500);

        vm.pay_inline = () => {
            console.log('pay');
            const name = `${ vm.data.student_name }'s Class (ID::${ vm.data.id })`;

            var request = {
                method: 'POST',
                route: URLS.base + `/2co/inline/${ name }`,
            };
            QueryService.query(request)
                .then(
                    function(response) {

                        const signature = response.data.data.signature;
                        console.log(signature);

                        pay(signature);

                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });

            function pay(signature){
                TwoCoInlineCart.setup.setMode('DYNAMIC');
                TwoCoInlineCart.cart.setCurrency('KRW');
                TwoCoInlineCart.products.add({
                    name: name,
                    quantity: 1,
                    price: vm.data.tuition,
                });
                // TwoCoInlineCart.cart.setSignature('718e810fee34be2bf4b9d4582323aa37580c4011ef694116cca5b0bb7badd2f1');
                TwoCoInlineCart.cart.setSignature(signature);
                TwoCoInlineCart.cart.checkout();
            }

        }


        vm.ccNo = 378282246310005
        vm.expMonth = 3
        vm.expYear = 2023
        vm.cvv = 560

        vm.disabled = () => {
            return !(
                vm.ccNo &&
                vm.expMonth &&
                vm.expYear &&
                vm.cvv
            );
        }

        vm.pay = () => {

            if(!vm.read_terms){
                document.getElementById('read').focus();
                return;
            }

            var request = {
                method: 'POST',
                route: URLS.base + `/2co/buy-link/${ vm.id }`,
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        const url = response.data.data.url;
                        console.log(url);

                        const win = window.open(url, '_blank');
                        win.focus();
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        function success(data){
            console.log('success', data.response);

            data.response.regular_class_id = vm.id;

            var request = {
                method: 'POST',
                route: URLS.base + `/payment/2checkout`,
                body: data.response
            };
            QueryService.query(request)
                .then(
                    function(response) {
                        console.log(vm.data);
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        function error(){
            console.log('error', data);
        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/payment-module2/payment-module.component.js